export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sport-top-banner.vue?vue&type=template&id=324747a2"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/sport-banners/sport-top-banner.vue?vue&type=template&id=324747a2
// module id = Ch4v
// module chunks = 0